<template lang="">
    <div>
         <div v-if="!esIframe && !es_pdf" >
            <!-- {{estados}} -->
            <img id='imagen' class='fondo' src="@/assets/planta2.png" alt="Planta">
            <!-- general -->
            <div v-if="tipo==''">
                <zona :estado="estado(1)" @click="clicked(4)" titulo="Transformadores" position="absolute" heigth="11%" width="4%" top="63%" left="70%" />
                <zona :estado="estado(2)" @click="clicked(6)" titulo="Mantenimiento" position="absolute" heigth="6%" width="3%" top="27.5%" left="56%" />
                <zona :estado="estado(3)" @click="clicked(5)" titulo="Evaporativo" position="absolute" heigth="7%" width="6.5%" top="40%" left="87%" />
                <zona :estado="estado(4)" @click="clicked(7)" titulo="Pozo" position="absolute" heigth="7%" width="6.5%" top="17%" left="71%" />
                <zona :estado="estado(5)" @click="clicked(2)" titulo="Barrenado" position="absolute" heigth="13%" width="6%" top="34%" left="51%" />

                <zona :estado="estado(6)" @click="clicked(8)" titulo="Grupo contra incendios" position="absolute" heigth="5%" width="3%" top="29.5%" left="73.5%" />
                <zona tipo="iframe" @click="mostrarIframe(true,rutaGas)" titulo="Gas" position="absolute" heigth="10%" width="8%" top="47%" left="80.5%" />
                <!-- <zona tipo="iframe" @click="mostrarIframe(false,rutaCompresores)" titulo="Compresores" position="absolute" heigth="4%" width="8%" top="59%" left="72%" />
                <zona tipo="iframe" @click="mostrarIframe(false,rutaArgon)" titulo="Argon" position="absolute" heigth="6%" width="3%" top="27.5%" left="52%" />
                
                 -->
                <!-- <zona tipo="iframe"  @click="mostrarIframe(true)" titulo="Pozo" position="absolute" heigth="10%" width="8%" top="47%" left="80.5%" /> -->
                <zona :estado="estado(7)" @click="clicked(9)" titulo="greentech" position="absolute" heigth="5%" width="3%" top="40%" left="78%" />


                <zona :estado="estado(8)" @click="clicked(10)" titulo="greentech" position="absolute" heigth="5.5%" width="6%" top="59%" left="74%" />
                <zona :estado="estado(9)" @click="clicked(11)" titulo="greentech" position="absolute" heigth="18%" width="4.5%" top="33%" left="68.5%" />


                <zona :estado="estado(10)" @click="clicked(12)" titulo="Filtro prensa" position="absolute" heigth="5%" width="2%" top="40%" left="75.5%" />

            </div>
            <!-- Documentacion -->
            <div v-if="tipo=='documentacion'">
                <zona tipo="iframe" @click="clicked(2)" titulo="Barrenado" position="absolute" heigth="21%" width="15%" top="29%" left="47%" />
                <zona tipo="iframe" @click="clicked(8)" titulo="Centrifugacion" position="absolute" heigth="21%" width="9%" top="29%" left="62%" />
                <zona tipo="iframe" @click="clicked(200)" titulo="Sala centrifugadoras verticales" position="absolute" heigth="13%" width="7%" top="39%" left="71%" />
                <zona tipo="iframe" @click="mostrarIframe(true,'https://wetys.gasnaturalfenosa.es/login.asp')" titulo="Gas" position="absolute" heigth="10%" width="8%" top="47%" left="80.5%" />
                <zona tipo="iframe" @click="clicked(201)" titulo="Soldadura" position="absolute" heigth="22%" width="23%" top="29%" left="24%" />
                <zona tipo="iframe" @click="pdfDirecto('/REBABADO 1.pdf')" titulo="Rebarbado1" position="absolute" heigth="5%" width="5%" top="34%" left="19%" />
                <zona tipo="iframe" @click="pdfDirecto('/REBABADO 2.pdf')" titulo="Rebarbado2" position="absolute" heigth="5%" width="5%" top="39%" left="19%" />
                <zona tipo="iframe" @click="pdfDirecto('/REBABADO 3.pdf')" titulo="Rebarbado3" position="absolute" heigth="5%" width="5%" top="44%" left="19%" />
                <zona tipo="iframe" @click="pdfDirecto('/BUNKER.pdf')" titulo="Bunker" position="absolute" heigth="12%" width="6%" top="13%" left="14%" />
                <zona tipo="iframe" @click="pdfDirecto('/POZO.pdf')" titulo="Pozo" position="absolute" heigth="7%" width="5%" top="16%" left="71.5%" />
                <zona tipo="iframe" @click="pdfDirecto('/EVAPORATIVO.pdf')" titulo="Evaporativo" position="absolute" heigth="7%" width="5%" top="40.5%" left="89%" />
                <zona tipo="iframe" @click="clicked(300)" titulo="Compresores" position="absolute" heigth="6%" width="8%" top="59%" left="72%" />
                <zona tipo="iframe" :showTitle="true" @click="clicked(310)" titulo="TORRES" position="absolute" heigth="4%" width="4%" top="25%" left="73%" />
                <zona tipo="iframe" @click="pdfDirecto('/pdf/periferia/TALADRO EXTERIOR.pdf')" titulo="Taladro exterior" position="absolute" heigth="4%" width="2.6%" top="24%" left="27.5%" />
                <zona tipo="iframe" @click="pdfDirecto('/pdf/periferia/GRUPO CONTRA INCENDIOS.pdf')" titulo="Grupo contra incendios" position="absolute" heigth="2%" width="1.75%" top="30%" left="73.8%" />
                <zona tipo="iframe" @click="pdfDirecto('/pdf/periferia/DEPOSITO GASOIL.pdf')" titulo="DEPOSITO GASOIL" position="absolute" heigth="2.5%" width="1%" top="30%" left="75.5%" />
                <zona tipo="iframe" @click="pdfDirecto('/pdf/periferia/FILTRO PRENSA.pdf')" titulo="FILTRO PRENSA" position="absolute" heigth="3.5%" width="1%" top="45%" left="78.6%" />
            </div>

            <!-- <zona :estado="estado(7)" titulo="Sótano" position="absolute" heigth="6.5%" width="6%" top="41.5%" left="51%" /> -->
            <div v-if="tipo=='subzona_documentacion'">
            </div>
        </div>
     
        <div v-if="es_pdf">
           {{currentPage}} / {{pageCount}}
           <pdf :src="src"
           @num-pages="pageCount = $event"
			@page-loaded="pdfCargado($event)"
            :page="currentPage"
            
           ></pdf>
        
            <v-btn depressed @click="before">
            <
            </v-btn>
            <input type="number" class="text-center" :max="pageCount" v-model.number="currentPage"/>
                <v-btn depressed @click="next">
            >
            </v-btn>
            <button class="btn btn-primary btn-block" @click="exitPDF" color="success">Salir</button>
        </div>
    </div>
   
</template>
<script>
import pdf from 'vue-pdf'
import Zona from './Zona.vue'
import { mapState } from 'vuex'

export default {
    components: {
        pdf,Zona
    },
    data() {
        return {
            rutaGas:'https://wetys.gasnaturalfenosa.es/login.asp',
            rutaCompresores:'https://wetys.gasnaturalfenosa.es/login.asp',
            rutaArgon:'',
            esIframe: false,
            es_pdf:false,
            lastValue:0,
            src:'',
            currentPage: 1,
			pageCount: 0,
            volverADocumentacionRaiz:false
        }
    },    
    props: {
        estados: {
            type: Object,
            default: {}
        },
        tipo:{
            type:String,
            default:''
        }
    },

    computed: {
        ...mapState(['potencia_inmovil'])
    },

    methods: {
        anda(){
            alert("aqui")
        },
        exitPDF(){
            if(this.volverADocumentacionRaiz){
                 this.$router.push({
                    name: 'Documentacion',
                    // params: {
                    //     'id': p,
                    //     'tipo':1
                    // }
                })
            }
            this.es_pdf=false;
        },
        pdfCargado(ev){
            this.currentPage = ev
        },
        next(){
            if(this.currentPage+1<this.pageCount)this.currentPage++;
        },
        before(){
            if(this.currentPage>1)this.currentPage--;
        },
        mostrarIframe(q,ruta) {
            // this.esIframe = q;
            console.log(q);
            if(q){
                // window.open('https://wetys.gasnaturalfenosa.es/login.asp','_blank','fullscreen="no"')
                window.open(ruta,'_blank','fullscreen="no"')
            }
        },
        
        pdfDirecto(ruta){
            this.volverADocumentacionRaiz=true;
             this.$router.push({
                name: 'DocumentacionZonaPDF',
                params: {
                    'ruta': ruta,
                    'tipo':2
                }
            })
            
        },
        clicked(p) {
            this.esIframe = false;
           
            console.log("clicked en principal", p)
            if(this.tipo==''){
                this.$router.push({
                name: 'Zona',
                params: {
                    'id': p,
                    'tipo':0,
                
                }
            })
            }
            else if (this.tipo=='documentacion'){
                this.volverADocumentacionRaiz=false;
                this.lastValue=p
                this.$router.push({
                    name: 'DocumentacionZona',
                    params: {
                        'id': p,
                        'tipo':1,
                    
                    }
                })
            }
            else{
               
                //pdf
               

                // switch (p) {
                //     case 4:
                //         //alert("Estu")
                //         this.src = pdf.createLoadingTask('T1.pdf');
                //         break;
                
                //     default:
                //         break;
                // }
                // this.es_pdf=true;

            }

            

        },

        estado(p) {
            switch (p) {
                case 0:
                    return this.estados.estado0;
                case 1:
                    return this.estados.estado1 || this.potencia_inmovil;

                case 2:
                    return this.estados.estado2;
                case 3:
                    return this.estados.estado3;
                case 4:
                    return this.estados.estado4;
                case 5:
                    return this.estados.estado5;
                case 6:
                    return this.estados.estado6;
                case 7:
                    return this.estados.estado7;
                case 8:
                    return this.estados.estado8;
                case 10:
                    return this.estados.estado10;

                default:
                    break;
            }
        }
    },

    
}
</script>
<style scoped>
    .fondo {
    position: absolute;
    height: 100%;
    width: 100%;
    /*width: 100%;*/
    /*object-fit: cover;*/
    top: 0%;
    left: 0px;
}

iframe {
    display: block;
    /* iframes are inline by default */
    background: #000;
    border: none;
    /* Reset default border */
    height: 80vh;
    /* Viewport-relative units */
    width: 100vw;
}
</style>